import React from "react";

function Footer() {
  return (
    <footer style={{
      width: "100%",
      padding: "22px 0",
      background: "linear-gradient(90deg, #a993ea 0%, #5048b6 100%)",
      color: "#fff",
      fontWeight: "600",
      fontSize: "1.2rem",
      textAlign: "center",
      boxShadow: "0 -5px 32px rgba(80,72,182,0.18)",
      position: "fixed",
      left: 0,
      bottom: 0,
      zIndex: 100,
      letterSpacing: "0.5px"
    }}>
      <span>
        Made with <span style={{color:"#ff7171",fontSize:"1.4em"}}>♥</span> by 
        <span style={{
          color: "#fff200", 
          fontWeight: 900, 
          paddingLeft: "8px", 
          paddingRight: "4px", 
          fontSize: "1.3em"
        }}>Dinesh</span>
        &nbsp;|&nbsp; 
        <span style={{opacity: 0.72}}>
          © {new Date().getFullYear()} All rights reserved.
        </span>
      </span>
    </footer>
  );
}

export default Footer;
